import PerPage from './per-page';
export default PerPage;
